"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props) {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Overlay).call(this, props));
    _this.listenForEscapeKey = _this.listenForEscapeKey.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _reactModal.default.setAppElement(this.props.appElement);

      document.addEventListener('keydown', this.listenForEscapeKey);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.listenForEscapeKey);
    }
  }, {
    key: "listenForEscapeKey",
    value: function listenForEscapeKey(e) {
      if (e.key === 'Escape') {
        this.props.onRequestClose();
      }
    }
  }, {
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        "rhe-overlay": true
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_reactModal.default, _extends({
        className: this._getClassNames(),
        shouldCloseOnOverlayClick: true,
        onRequestClose: this.props.onRequestClose,
        ariaHideApp: false,
        isOpen: this.props.isOpen
      }, this.props), _react.default.createElement("div", {
        className: 'rhe-overlay__container'
      }, _react.default.createElement("div", {
        className: "rhe-overlay__header"
      }, this.props.showClose && _react.default.createElement("span", {
        tabIndex: "0",
        "aria-label": "Close overlay",
        role: "button",
        className: "rhe-overlay__close",
        onClick: this.props.onClose.bind(this)
      }), _react.default.createElement("h2", {
        className: "rhe-overlay__title"
      }, this.props.title)), _react.default.createElement("div", {
        className: "rhe-overlay__content"
      }, this.props.children)));
    }
  }]);

  return Overlay;
}(_react.default.Component);

exports.default = Overlay;
Overlay.defaultProps = {
  appElement: document.getElementById('root'),
  customStyles: {},
  onRequestClose: function onRequestClose() {},
  isOpen: false,
  onClose: function onClose() {},
  showClose: true
};
Overlay.propTypes = {
  className: _propTypes.default.string,
  onRequestClose: _propTypes.default.func,
  isOpen: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  title: _propTypes.default.string,
  showClose: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['true', 'false'])])
};